<script setup lang="ts">
import { computed } from 'vue';

import useContext from '@/composables/useContext';
import useGiftCard from '@/composables/useGiftCard';
import FavoriteButton from '@/components/FavoriteButton.vue';

const { channel } = useContext();
const { activeGiftCard } = useGiftCard();

const favoritesPageUrl = computed(() => channel.value?.giftcardFavoritesPageUrl || '');
const amountOfFavorites = computed(() => activeGiftCard.value?.favoriteProductIds?.length || 0);
const hasFavorites = computed(() => amountOfFavorites.value > 0);
</script>

<template>
  <router-link
    v-if="favoritesPageUrl"
    :to="favoritesPageUrl"
    class="inline-flex items-center text-foreground transition-colors hover:opacity-70"
    aria-label="Favorites"
  >
    <span class="relative inline-flex">
      <FavoriteButton
        :is-favorite="hasFavorites"
        size="sm"
        class="pointer-events-none"
      />
      <span
        v-if="hasFavorites"
        class="absolute -right-2 -top-1 inline-flex h-4 min-w-[16px] items-center justify-center rounded-full bg-foreground px-1 text-[10px] leading-none text-background"
      >
        {{ amountOfFavorites }}
      </span>
    </span>
  </router-link>
</template>
